import React from "react";

interface EvaluationTimerProps {
  minutes: number;
  seconds: number;
}

export const EvaluationTimer: React.FC<EvaluationTimerProps> = ({
  minutes,
  seconds,
}) => {
  return (
    <p className="stopwatch-time">
      {minutes.toString().padStart(2, "0")}:
      {seconds.toString().padStart(2, "0")}
    </p>
  );
};
